import { Link, Typography } from "@mui/material";
import React from "react";
import { useAuth } from "../hook/auth";
import { NoteBlockContainer } from "./note";

export const Forbidden: React.FC = () => {
  const { loginWithPopup, isAuthenticated } = useAuth();

  return (
    <NoteBlockContainer name="No Access">
      <Typography>Your account does not have access to this page.</Typography>
      {!isAuthenticated && (
        <Typography>
          <Link onClick={() => loginWithPopup()}>Login</Link> to access your
          workspaces.
        </Typography>
      )}
    </NoteBlockContainer>
  );
};
